/**
 * @generated SignedSource<<2ec64baa3789cb3d44e5cced880e411b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GoalScoringMode = "OKR" | "SIMPLE";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
export type DevWorkspaceSwitcherQuery$variables = Record<PropertyKey, never>;
export type DevWorkspaceSwitcherQuery$data = {
  readonly allWorkspaces: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly cloudId: string;
        readonly goalScoringMode: GoalScoringMode;
        readonly id: string;
        readonly keyPrefix: string;
        readonly name: string;
        readonly organisationId: string;
        readonly timezone: string;
        readonly type: WorkspaceType;
        readonly uuid: string;
      } | null;
    } | null> | null;
  } | null;
};
export type DevWorkspaceSwitcherQuery = {
  response: DevWorkspaceSwitcherQuery$data;
  variables: DevWorkspaceSwitcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "WorkspaceConnection",
    "kind": "LinkedField",
    "name": "allWorkspaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "WorkspaceEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "uuid"
              },
              {
                "kind": "ScalarField",
                "name": "keyPrefix"
              },
              {
                "kind": "ScalarField",
                "name": "timezone"
              },
              {
                "kind": "ScalarField",
                "name": "cloudId"
              },
              {
                "kind": "ScalarField",
                "name": "organisationId"
              },
              {
                "kind": "ScalarField",
                "name": "goalScoringMode"
              },
              {
                "kind": "ScalarField",
                "name": "type"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DevWorkspaceSwitcherQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DevWorkspaceSwitcherQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8d9d20d03d49f525f7ca4d089ba5e1b8",
    "id": null,
    "metadata": {},
    "name": "DevWorkspaceSwitcherQuery",
    "operationKind": "query",
    "text": "query DevWorkspaceSwitcherQuery {\n  allWorkspaces {\n    edges {\n      node {\n        name\n        id\n        uuid\n        keyPrefix\n        timezone\n        cloudId\n        organisationId\n        goalScoringMode\n        type\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ec915f1db0831e88ba581c4df52179e";

export default node;
